'use client'

import useAddToHomescreenPrompt from '../../a2hs-button/use-add-to-home-screen'

type Props = {
  css: string
}

const A2hsShimmer = ({css}: Props) => {
  const {showA2HS} = useAddToHomescreenPrompt()

  return !showA2HS && <div className={css} />
}

export default A2hsShimmer
